import { handleActions } from 'redux-actions';
import { AvailablePhoneNumbersModel } from '../../../components/phones/twilio/twilio-models.interface';
import {
  addNewNumberFailureMessage,
  addNewNumberSuccessMessage,
  clearAvailablePhoneNumbers,
  newNumberFailureMessages,
  newNumberSuccessMessages,
  purchasePhoneNumbers,
  purchasePhoneNumbersSuccess,
} from './twilio.action';

export type TwilioState = {
  availablePhoneNumbers: AvailablePhoneNumbersModel;
  purchasingNumbers: boolean;
  newNumberSuccessMessages: string[];
  newNumberFailureMessages: string[];
};

const twilioDefaultState = {
  availablePhoneNumbers: {
    available_phone_numbers: [],
    uri: '',
  },
  purchasingNumbers: false,
  newNumberSuccessMessages: [],
  newNumberFailureMessages: [],
};

const twilioReducer = handleActions<any, any>(
  {
    [clearAvailablePhoneNumbers.toString()]: (state, action) =>
      Object.assign({}, state, {
        availablePhoneNumbers: { available_phone_numbers: [], uri: '' },
      }),
    [purchasePhoneNumbers.toString()]: (state, action) =>
      Object.assign({}, state, {
        purchasingNumbers: true,
        newNumberSuccessMessages: [],
        newNumberFailureMessages: [],
      }),
    [newNumberSuccessMessages.toString()]: (state, action) =>
      Object.assign({}, state, { newNumberSuccessMessages: action.payload }),
    [newNumberFailureMessages.toString()]: (state, action) =>
      Object.assign({}, state, { newNumberFailureMessages: action.payload }),
    [addNewNumberSuccessMessage.toString()]: (state, action) =>
      Object.assign({}, state, {
        newNumberSuccessMessages: [...state.newNumberSuccessMessages, action.payload],
      }),
    [addNewNumberFailureMessage.toString()]: (state, action) =>
      Object.assign({}, state, {
        newNumberFailureMessages: [...state.newNumberFailureMessages, action.payload],
      }),
    [purchasePhoneNumbersSuccess.toString()]: (state, action) =>
      Object.assign({}, state, { purchasingNumbers: false }),
  },
  twilioDefaultState
);

export default twilioReducer;
